export default "__VITE_ASSET__6214a0e4__"